
import './App.css';
import React, { useEffect, useState } from 'react';
import instance from "./axios-instance";
import Systems from "./SystemFunction";
import { useLang } from './site/i18n';
import menu from './site/content/menu';

// เมนูซ้ายตามเว็บตัวอย่าง (label แปลตามภาษา: src/site/locales/*.json)
const ITEMS = [
  { key: 'home', path: '/', label: 'menu.popular' },
  { key: 'slot', path: '/slot', label: 'menu.slot' },
  { key: 'casino', path: '/casino', label: 'menu.casino' },
  { key: 'sport', path: '/sport', label: 'menu.sport' },
  { key: 'fishing', path: '/fishing', label: 'menu.fishing', icon: 'crash' },
  { key: 'cards', path: '/cards', label: 'menu.cards' },
  { key: 'other', path: '/other', label: 'menu.other', icon: 'keno' },
];

// ไอคอนสำรอง ถ้ายังไม่ได้รัน clone-site (ไอคอนจริงมาจาก src/site/content/menu.js)
const FALLBACK_ICON = {
  home: "https://ideabet.fun/theme/mcblue/wp-content/uploads/2022/08/Artboard-5-300x300-1.png",
  slot: "https://ideabet.fun/theme/mcblue/wp-content/uploads/2022/08/slot-1.png",
  casino: "https://ideabet.fun/theme/mcblue/wp-content/uploads/2022/08/casino.png",
  sport: "https://ideabet.fun/theme/mcblue/wp-content/uploads/2022/08/Artboard-5-300x300-1.png",
  contact: "https://ideabet.fun/theme/mcblue/wp-content/uploads/2022/08/call.png",
};

// ไอคอนของเว็บเอง (public/build/web/igame-index-lobby-wm/img/)
const IMG = '/build/web/igame-index-lobby-wm/img/';
const SITE_ICONS = {
  home: IMG + 'ยอดนิยม.png', slot: IMG + 'สล็อตเกม.png', casino: IMG + 'คาสิโนสด.png', sport: IMG + 'กีฬา.png',
  lotto: IMG + 'หวย.png', fishing: IMG + 'เกมกราฟ.png', cards: IMG + 'เกมไพ่.png', other: IMG + 'คีโน.png', demo: IMG + 'ทดลองเล่น.png',
};

function iconFor(key) {
  if (SITE_ICONS[key]) return SITE_ICONS[key];
  const found = ((menu && menu.left) || []).find((m) => m.key === key && m.img);
  return found ? found.img : FALLBACK_ICON[key] || FALLBACK_ICON.home;
}

export default function Sidebar() {
  const { t } = useLang();
  const [linelink, setLinelink] = useState('');
  const [, setRoute] = useState(0);
  // เปลี่ยนหน้าแบบไม่ reload -> อัปเดตเมนูที่เลือกอยู่
  useEffect(() => {
    const onPop = () => setRoute((n) => n + 1);
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);
  const pathname = '/' + window.location.pathname.replace(/^\/+|\/+$/g, '');

  useEffect(() => {
    instance.post("/api/v1/mainsetting", { System: Systems })
      .then((res) => {
        if (res.data.status === 200) setLinelink(res.data.message[1].value);
      })
      .catch(() => { });
  }, []);

  return (
    <div className="tabgamemenu">
      <div className="menu-menu-left-container">
        <ul id="menu-menu-left" className="menu">
          {ITEMS.map((item) => {
            const active = pathname === item.path || (item.path !== '/' && pathname.startsWith(item.path + '/')) || (item.key === 'slot' && pathname.startsWith('/listgameall/slot'));
            return (
              <li key={item.key}
                className={`menu-item menu-item-type-post_type menu-item-object-page${active ? ' current-menu-item current_page_item' : ''}`}>
                <a href={item.path} aria-current={active ? 'page' : undefined}
                  className="menu-image-title-after menu-image-not-hovered">
                  <img width={300} height={300} src={iconFor(item.key)}
                    className="menu-image menu-image-title-after" alt="" decoding="async" />
                  <span className="menu-image-title-after menu-image-title">{t(item.label)}</span>
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
